import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { Tab, Button } from 'react-bootstrap';

import Delightable from '../../../../components/delightable';
import StageDisplay from './Stage';

import styles from './styles.css';

class SallerReasonTab extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.showInsight = this.showInsight.bind(this);
    this.requestAddSellerFeedback = this.requestAddSellerFeedback.bind(this);
  }

  componentDidMount() {
    this.props.measure();
  }

  showInsight(feedback) {
    this.props.requestShowInsight(feedback.insight_id);
  }

  requestAddSellerFeedback() {
    this.props.requestAddSellerFeedback(this.props.object);
  }

  renderHTML(raw) {
    return <span dangerouslySetInnerHTML={{ __html: raw }} />;
  }

  renderTokens(salesReps, reasons) {
    const total = reasons.length;
    return reasons.map((reason, i) => {
      let suffix = null;
      let prefix = null;
      if (i < total - 2) {
        suffix = (<span>, </span>);
      } else if (total > 1 && i === total - 1) {
        prefix = (<span className={styles.ampersand}> &amp; </span>);
      }

      const { attribute } = reason;
      return (
        <span key={reason.id}>
          {prefix}
          <a style={{ display: 'inline-block' }} href="" onClick={(e) => { e.preventDefault(); this.props.requestShowAttribute(attribute, reason, salesReps); }}>{attribute.seller_label}</a>
          {suffix}
        </span>
      );
    });
  }

  renderItem(feedback) {
    const { object: { stage } } = this.props;
    const firstReason = feedback.reasons ? feedback.reasons[0] : null;
    if (!firstReason) {
      return null;
    }

    const isWon = stage === 'Won';
    let outcome = (<StageDisplay value={stage} type="verb" />);
    if (isWon) {
      outcome = (
        <Delightable>{outcome}</Delightable>
      );
    }

    let salesReps = null;
    if (firstReason.seller_first_name && firstReason.seller_last_name) {
      salesReps = {
        sales_profile_url: firstReason.sales_profile_url,
        first_name: firstReason.seller_first_name,
        last_name: firstReason.seller_last_name,
      };
    } else {
      salesReps = feedback.sales_reps ? feedback.sales_reps[0] : null;
    }

    let salesRepsComp = null;
    if (salesReps) {
      salesRepsComp = (
        <strong>{salesReps.first_name} {salesReps.last_name}</strong>
      );
      if (salesReps.sales_profile_url) {
        salesRepsComp = (
          <a href={salesReps.sales_profile_url}>{salesRepsComp}</a>
        );
      }
    }

    let priceStr = null;
    const impact = (firstReason.impact_text || '').replace('Impact', '').replace('impact', '');

    if (feedback.price_position && feedback.price_position !== 'Unknown' && feedback.primary_competitor_name) {
      let pp = feedback.price_position;
      let cls = pp === 'Higher' ? 'text-danger' : 'text-success';
      if (pp === 'NA') {
        pp = 'unknown';
        cls = null;
      }
      let competitor = firstReason.vendor_name;
      if (firstReason.vendor_battlecard) {
        competitor = (<a target="_blank" href={firstReason.vendor_battlecard}>{firstReason.vendor_name}</a>);
      }
      let priceCompare = '';
      if (pp === 'Similar') {
        priceCompare = 'to';
      } else if (pp === 'unknown') {
        priceCompare = 'versus';
      } else {
        priceCompare = 'than';
      }

      priceStr = (<span>Our price position was <span className={`${cls} text-lowercase`}>{pp}</span> {priceCompare} <strong>{competitor}</strong>.</span>);
    }
    return (
      <div key={`${feedback.seller_crm_id}|${feedback.client_id}|${feedback.initiative_id}`} className="well well-sm clearfix">
        {salesRepsComp}{(salesRepsComp !== null ? ': ' : '')} We {outcome} because we had a <span className="text-lowercase">{impact} {firstReason.classification_text}</span> in {this.renderTokens(salesReps, feedback.reasons)}. {priceStr}
      </div>
    );
  }

  renderList() {
    const { object } = this.props;
    const feedbacks = object.seller_feedbacks || [];

    if (feedbacks.length === 0) {
      return (
        <div className={styles.section}>
          <div className="well well-sm clearfix">No feedback found.</div>
        </div>
      );
    }

    return (
      <div className={styles.section}>
        {feedbacks.map(feedback => this.renderItem(feedback))}
      </div>
    );
  }

  renderEmpty() {
    const { object } = this.props;
    const { stage } = object;
    let suffix = '';
    if (stage) {
      let s = 'won';
      if (stage === 'Lost') {
        s = 'lost';
      } else if (stage === 'No Decision') {
        s = 'pushed';
      }
      suffix = `on why we ${s}`;
    }
    return (
      <div className={`${styles.section} text-left`}>
        <div className="well well-sm">
          <Button onClick={this.requestAddSellerFeedback} bsStyle="default"><Fa name="plus" /> provide seller reasons</Button> {' '} {suffix}.
        </div>
      </div>
    );
  }

  render() {
    const { eventKey, title, totalFeedbacks } = this.props;
    return (
      <Tab
        eventKey={eventKey}
        title={title}
      >
        <div>
          {totalFeedbacks === 0 && this.renderEmpty()}
          {totalFeedbacks > 0 && this.renderList()}
        </div>
      </Tab>
    );
  }
}

SallerReasonTab.propTypes = {
  object: PropTypes.shape({
    opportunity_id: PropTypes.string,
    account_id: PropTypes.string,
    has_seller_feedback: PropTypes.bool,
    seller_feedbacks: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  eventKey: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  totalFeedbacks: PropTypes.number,
  feedbacks: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired, // array of arrays
  requestShowInsight: PropTypes.func,
  isAccount: PropTypes.bool,
  measure: PropTypes.func,
  requestAddSellerFeedback: PropTypes.func,
  requestShowAttribute: PropTypes.func,
};

SallerReasonTab.defaultProps = {
  totalFeedbacks: 0,
  requestShowInsight: () => {},
  isAccount: false,
  measure: () => {},
  requestAddSellerFeedback: () => {},
  requestShowAttribute: () => {},
};

export default SallerReasonTab;
